var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teams---single-user",
    transform: "translate(-126.000000, -655.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-mastercard",
    transform: "translate(126.000000, 655.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,17.3333333 C28,18.806 26.806,20 25.3333333,20 L2.66666667,20 C1.194,20 0,18.806 0,17.3333333 L0,2.66666667 C0,1.194 1.194,0 2.66666667,0 L25.3333333,0 C26.806,0 28,1.194 28,2.66666667 L28,17.3333333 Z",
    id: "Path",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFC107",
    cx: 18,
    cy: 10,
    r: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.676,14 C12.3666667,13.5886667 12.1006667,13.144 11.892,12.6666667 L15.442,12.6666667 C15.6273333,12.2426667 15.7726667,11.7973333 15.8666667,11.3333333 L11.468,11.3333333 C11.38,10.9026667 11.3333333,10.4573333 11.3333333,10 L16,10 C16,9.54266667 15.9533333,9.09733333 15.866,8.66666667 L11.4673333,8.66666667 C11.562,8.20266667 11.7066667,7.75733333 11.892,7.33333333 L15.442,7.33333333 C15.2333333,6.856 14.968,6.41133333 14.658,6 L12.676,6 C12.9673333,5.61333333 13.296,5.252 13.6633333,4.93666667 C12.498,3.93933333 10.9873333,3.33333333 9.33333333,3.33333333 C5.65133333,3.33333333 2.66666667,6.318 2.66666667,10 C2.66666667,13.682 5.65133333,16.6666667 9.33333333,16.6666667 C11.5126667,16.6666667 13.4413333,15.6166667 14.6573333,14 L12.676,14 Z",
    id: "Path",
    fill: "#FF3D00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMastercard);
export default __webpack_public_path__ + "static/media/icon-mastercard.71ea17a0ea2a27928e9ae3a0e2135dfb.svg";
export { ForwardRef as ReactComponent };